import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { getUser } from './authService';
import PageLoading from '@/components/PageLoading';

interface Props {
    children: React.JSX.Element;
    requiredRoles?: string[]; // optional: role-based
}

const RequireAuth = ({ children, requiredRoles }: Props): React.JSX.Element => {
    const navigate = useNavigate();
    const { pathname } = useLocation()
    const [searchParams] = useSearchParams()

    const [allowed, setAllowed] = useState<boolean | null>(null);

    useEffect(() => {
        let active = true;

        getUser().then((user: any) => {
            if (!user || user.expired) {
                let next = pathname
                if (searchParams.size > 0) {
                    next += '?' + searchParams.toString()
                }
                navigate('/login?next=' + encodeURIComponent(next)); // redirect nếu chưa đăng nhập
                return;
            }

            // Nếu yêu cầu quyền cụ thể
            if (requiredRoles && requiredRoles.length > 0) {
                const userRoles = user.profile.role || [];
                const hasRole = requiredRoles.some(role => userRoles?.includes(role));
                if (active) {
                    setAllowed(hasRole);
                }
                if (!hasRole) navigate('/forbidden'); // không đủ quyền
            } else {
                if (active) {
                    setAllowed(true);
                }
            }
        });

        return () => {
            active = false
        }
    }, [navigate, requiredRoles, pathname, searchParams]);

    if (allowed === null) return <PageLoading message='Đang kiểm tra quyền truy cập...' />;

    return allowed ? children : <React.Fragment />;
};

export default RequireAuth;
